var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Label } from "./..";
var HiddenInput = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1;\n"], ["\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1;\n"])));
export var FileUploadInput = function (_a) {
    var onFileSelection = _a.onFileSelection, _b = _a.label, label = _b === void 0 ? 'Select File to Upload' : _b, id = _a.id, accept = _a.accept, lss = _a.lss;
    var idString = id ? id + "-select-and-upload" : 'select-and-upload';
    return (React.createElement(React.Fragment, null,
        React.createElement(HiddenInput, { id: idString, type: "file", value: "", accept: accept, onChange: function (e) {
                if (e.target.files && e.target.files.length === 0)
                    return;
                e.target.files && onFileSelection(e.target.files[0]);
            } }),
        React.createElement(Label, { tabIndex: 0, htmlFor: idString, lss: __assign({ px: 'sm', py: 'xs', m: 0, cursor: 'pointer', ':hover': { color: 'secondary500' } }, lss) }, label)));
};
var templateObject_1;
//# sourceMappingURL=FileUploadInput.js.map